import { render, staticRenderFns } from "./WebPayNotificationsTable.vue?vue&type=template&id=c3bcbf94&"
import script from "./WebPayNotificationsTable.vue?vue&type=script&lang=js&"
export * from "./WebPayNotificationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports